import { render, staticRenderFns } from "./CustomTag.vue?vue&type=template&id=25aa2966&"
import script from "./CustomTag.vue?vue&type=script&lang=js&"
export * from "./CustomTag.vue?vue&type=script&lang=js&"
import style0 from "./CustomTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports